import React from 'react';
import PropTypes from 'prop-types';
import { Step, Stepper, StepLabel } from 'material-ui';
import { getStatusColor } from '../../../contracting/contractingUtils';

import injectSheet from 'react-jss';

import CircleCheck from 'material-ui/svg-icons/action/check-circle';

const { arrayOf, number, object, shape, string } = PropTypes;

const styles = {};

const getPercentage = (total, compare) => total ? (compare / total) : 0;

const Funnel = ({ classes, data }) =>
  <Stepper orientation="vertical">
    { data.map((step, i) => {
      // Only calculate going forward for > 0 index
      const percentage = Math.round(getPercentage(data[0].value, step.value) * 100);

      return (<Step style={{ padding: '8px auto', marginTop: 0 }} key={i}>
        <StepLabel style={{ height: '36px' }} completed={i === data.length - 1} icon={(i !== data.length - 1 ? (i + 1) : <CircleCheck style={{ fill: getStatusColor(step.status) }} />)}>
          <div style={{ color: '#383838', fontSize: '14px', fontWeight: '600', minWidth: '125px', padding: '0 16px' }}>
            {percentage}% &nbsp;
            <small style={{ fontWeight: '400' }}>
              {
                Boolean(i) ? `(${step.value}/${data[0].value})` : `(${step.value})`
              }
            </small>
          </div>
          <div style={{ height: '100%', width: '100%', display: 'flex' }}>
            <svg style={{ height: '100%', width: '100%' }}>
              <rect style={{ fill: 'rgb(200, 200, 200)', width: '100%', height: '100%' }}/>
              <rect style={{ fill: getStatusColor(step.status), width: `${percentage}%`, height: '100%' }}>
                <animate attributeName="width" from="0" to={`${percentage}%`} dur="0.5s" fill="freeze" />
              </rect>
              <text textAnchor="start" y="50%" dy=".35em">
                <tspan x="2%" style={{ fontSize: '11px' }}>{step.leftLbl}</tspan>
              </text>
              <text textAnchor="end" y="50%" dy=".35em">
                <tspan x="95%">{step.label}</tspan>
              </text>
            </svg>
          </div>
        </StepLabel>
      </Step>);
    }
    )}
  </Stepper>;

Funnel.propTypes = {
  classes: object,
  data: arrayOf(shape({
    label: string.isRequired,
    value: number.isRequired,
  })).isRequired,
};

export default injectSheet(styles)(Funnel);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/widgets/funnel.jsx